// @tennis-matches/services/auth
// Minimale Registrierungs-Intent-Wahl: Spieler / Trainer / Beides.

/** @typedef {"player"|"trainer"|"both"} SignupIntent */

export const SIGNUP_INTENT_PLAYER = "player";
export const SIGNUP_INTENT_TRAINER = "trainer";
export const SIGNUP_INTENT_BOTH = "both";

export const SIGNUP_INTENT_VALUES = Object.freeze([
  SIGNUP_INTENT_PLAYER,
  SIGNUP_INTENT_TRAINER,
  SIGNUP_INTENT_BOTH,
]);

/** @typedef {"club"|"family"|"training"|"trainer"} SignupRegisterHintId */

export const SIGNUP_REGISTER_HINT_IDS = Object.freeze([
  "club",
  "family",
  "training",
  "trainer",
]);

function __asLower(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

/**
 * @param {unknown} raw
 * @returns {SignupIntent|null}
 */
export function normalizeSignupIntent(raw) {
  const v = __asLower(raw);
  if (SIGNUP_INTENT_VALUES.includes(/** @type {SignupIntent} */ (v))) {
    return /** @type {SignupIntent} */ (v);
  }
  return null;
}

/**
 * @param {object|null|undefined} user
 * @returns {SignupIntent|null}
 */
export function resolveSignupIntentFromUser(user) {
  if (!user || typeof user !== "object") return null;
  const meta =
    user.user_metadata && typeof user.user_metadata === "object"
      ? user.user_metadata
      : user.raw_user_meta_data && typeof user.raw_user_meta_data === "object"
        ? user.raw_user_meta_data
        : {};
  return normalizeSignupIntent(meta.signup_intent);
}

/**
 * @param {SignupIntent|null|undefined} intent
 * @returns {boolean}
 */
export function isSignupIntentTrainerFacing(intent) {
  const normalized = normalizeSignupIntent(intent);
  return (
    normalized === SIGNUP_INTENT_TRAINER || normalized === SIGNUP_INTENT_BOTH
  );
}

/**
 * @param {SignupIntent|null|undefined} intent
 * @returns {SignupRegisterHintId[]}
 */
export function resolveSignupRegisterHintIds(intent) {
  const normalized = normalizeSignupIntent(intent);
  if (normalized === SIGNUP_INTENT_PLAYER) {
    return ["club", "family", "training"];
  }
  if (normalized === SIGNUP_INTENT_TRAINER) {
    return ["club", "trainer"];
  }
  if (normalized === SIGNUP_INTENT_BOTH) {
    return ["club", "family", "training", "trainer"];
  }
  return [];
}

/**
 * @param {SignupRegisterHintId} hintId
 * @returns {string}
 */
export function resolveSignupRegisterHintI18nKey(hintId) {
  return `auth.register.simple.hint.${String(hintId || "").trim()}`;
}
